import { array, object, string } from "yup";
import i18n from "../../../../locales/i18n";

const validationSchemaDocument = object({
  documents: array()
    .of(
      object().shape({
        documentFileId: string().required(
          i18n.t("resources.workOrders.valid.enter_file_category")
        ),

        description: string().required(
          i18n.t("resources.workOrders.valid.enter_description")
        ),
        file: object().shape({
          fileName: string().required("Doküman ekleyiniz."),
        }),
      })
    )
    .nullable(),
});
export default validationSchemaDocument;
